import React, { useMemo, forwardRef } from 'react';
import styles from './FJButton.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJAutoLoading from '../FJLoading/FJAutoLoading.jsx';

export const FJButtonType = {
    DEFAULT: 'default', // 灰色
    GRADIENT: 'gradient', // 彩色渐变
    WHITE: 'white', // 白色
    ORANGE: 'orange',
    CREDIT: 'credit', // 灰蓝色积分背景
    DEFAULT_GRADIENT: 'default-gradient',
};

const FJButton = forwardRef((props, ref) => {
    const {
        className,
        disabled,
        style,
        icon,
        text,
        onClick = () => {},
        type = 'default',
        textClassName,
        isLoading,
        loadingStyle,
    } = props;

    const cn = useMemo(() => {
        switch (type) {
            case FJButtonType.DEFAULT:
                return styles.default;
            case FJButtonType.GRADIENT:
                return styles.gradient;
            case FJButtonType.WHITE:
                return styles.white;
            case FJButtonType.ORANGE:
                return styles.orange;
            case FJButtonType.CREDIT:
                return styles.credit;
            case FJButtonType.DEFAULT_GRADIENT:
                return styles.default_gradient;
            default:
                return styles.default;
        }
    }, [type]);

    const _onClick = e => {
        if (isLoading || disabled) {
            return;
        }
        onClick(e);
    };

    return (
        <div
            ref={ref}
            className={classNames(cn, { [styles.disabled]: disabled }, className)}
            style={style}
            onClick={_onClick}
        >
            <div className={styles.btn_mask}></div>
            <div className={classNames(styles.btn, { [styles.opacity_0]: isLoading })}>
                {icon}
                {text && <span className={classNames(textClassName)}>{FJLocalStore._(text)}</span>}
            </div>
            {isLoading && (
                <FJAutoLoading
                    className={styles.loading}
                    shown={true}
                    innerStyle={loadingStyle}
                    strokeColor={type === FJButtonType.DEFAULT ? '#686c7e' : undefined}
                />
            )}
        </div>
    );
});
export default FJButton;
